import localeKr from "./kr/translation";
import localeEn from "./en/translation";

export const kr = localeKr;
export const en = localeEn;

export default { kr, en };
